interface Props {
  condition: boolean;
  wrap: (children: JSX.Element) => JSX.Element;
  children: JSX.Element;
}

export function WithWrapper({ condition, wrap, children }: Props) {
  return <>{condition ? wrap(children) : children}</>;
}
